export const SWITCH_SENDOVER_TO_SENDOUT_TYPES = {
  WithMail: 'withMail',
  WithoutMail: 'withoutMail'
};
